import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import {
  CREATE_GOLF_COURSE_UNAVAILABILITY,
  CREATE_GOLF_COURSE_UNAVAILABILITY_SUCCESS,
  CREATE_GOLF_COURSE_UNAVAILABILITY_ERROR,
} from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* createGolfCourseUnavailability({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-unavailable`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        admin: true,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: CREATE_GOLF_COURSE_UNAVAILABILITY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_GOLF_COURSE_UNAVAILABILITY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_GOLF_COURSE_UNAVAILABILITY_ERROR, payload: error });
  }
}

export function* watchCreateGolfCourseUnavailability() {
  yield takeEvery(CREATE_GOLF_COURSE_UNAVAILABILITY, createGolfCourseUnavailability);
}

function* createGolfCourseUnavailabilitySaga() {
  yield all([fork(watchCreateGolfCourseUnavailability)]);
}

export default createGolfCourseUnavailabilitySaga;
